import { useEffect, useState } from 'react';
import { fetchBlob } from '../lib/api';

/** Fetches an authenticated binary resource (works for cookie and bearer auth) and returns an object URL. */
export function useBlobUrl(path: string | null): { url: string | null; error: boolean; loading: boolean } {
  const [state, setState] = useState<{ url: string | null; error: boolean; loading: boolean }>({ url: null, error: false, loading: !!path });
  useEffect(() => {
    if (!path) return;
    let revoked = false;
    let url: string | null = null;
    setState({ url: null, error: false, loading: true });
    fetchBlob(path)
      .then((b) => {
        if (revoked) return;
        url = URL.createObjectURL(b);
        setState({ url, error: false, loading: false });
      })
      .catch(() => !revoked && setState({ url: null, error: true, loading: false }));
    return () => {
      revoked = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);
  return state;
}
